<form class="relative">
    <i class="fa-solid fa-magnifying-glass search-icon text-color-secondary" style="font-size: 1.25rem"></i>
    <p-autoComplete #autocomplete type="search" size="large" optionLabel="name" [placeholder]="placeholder"
        emptyMessage="Aucun résultat" appendTo="body" [disabled]="!country" [suggestions]="organizations" [forceSelection]="true"
        [showEmptyMessage]="true" [minLength]="3" [delay]="500" [inputStyleClass]="inputStyleClass"
        (completeMethod)="onSearch($event)" (onSelect)="onSelectOrganization($event)">
        <ng-template let-organization #item>
            <div class="flex flex-column gap-1 py-1">
                <span>{{organization.name}}</span>
                <span class="text-color-secondary text-sm">
                    {{organization.identifier}}
                    @if (organization.acronym) {
                        <span class="mx-2">&bull;</span>{{organization.acronym}}
                    }
                </span>
            </div>
        </ng-template>
    </p-autoComplete>
</form>